import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Outlet, Navigate } from 'react-router-dom'
import { setHostAnalyticsUser } from '../../utils/hostAnalytics'

const PrivateRoutes = () => {

    const { hostInfo } = useSelector((state) => state.host)

    useEffect(() => {
        if (hostInfo?._id) setHostAnalyticsUser(hostInfo._id)
    }, [hostInfo?._id])

    return (
        hostInfo ? <Outlet /> : <Navigate to="/login" />
    )
}

export default PrivateRoutes